import React from "react";
import { Form, Row, Col, InputGroup } from "react-bootstrap";
import Select from "react-select/creatable";

const RenderDetailField = ({
    id,
    name,
    label,
    value,
    children,
    onChange,
    onBlur,
    type = "text",
    placeholder = "",
    inputGroupText = null,
    inputGroupTextClassName = "",
    inputGroupTextStyle = null,
    disabled = false,
    as = "input",
    rows = 8,
    bsPrefix = null,
    controlClassName = "",
    controlStyle = null,
    isSelect = false,
    options = [],
    onInputChange = null,
    onCreateOption = null,
    isClearable = true,
    readOnly = false,
    onFocus,
}) => {
    const isDisabled = !!disabled;
    const isValueComponent = React.isValidElement(value);

    return (
        <Form.Group as={Row} controlId={id} className="mb-2">
            {/* column prop ensures vertical alignment of label text */}
            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>
                {label}
            </Form.Label>

            {/* Use d-flex and align-items-center to force the checkbox to the middle */}
            <Col className="d-flex align-items-center">
                {isValueComponent ? (
                    <div className="w-100 custom-render-wrapper">
                        {value}
                    </div>
                ) : children ? (
                    children
                ) : (
                    <InputGroup className="w-100">
                        {inputGroupText && (
                            <InputGroup.Text className={inputGroupTextClassName} style={inputGroupTextStyle}>
                                {inputGroupText}
                            </InputGroup.Text>
                        )}
                        {isSelect ? (
                            <div className="w-100">
                                <Select
                                    name={name || id}
                                    value={value}
                                    onChange={onChange}
                                    onBlur={onBlur}
                                    onFocus={onFocus}
                                    onInputChange={onInputChange}
                                    options={options || []}
                                    onCreateOption={onCreateOption}
                                    isClearable={isClearable}
                                    isDisabled={isDisabled}
                                    placeholder={placeholder || "Select..."}
                                    classNamePrefix="react-select"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        menu: (base) => ({ ...base, zIndex: 9999 })
                                    }}
                                />
                            </div>
                        ) : (
                            <Form.Control
                                name={name || id}
                                className={controlClassName}
                                style={controlStyle}
                                value={value || ''}
                                onChange={onChange}
                                onBlur={onBlur}
                                onFocus={onFocus}
                                readOnly={readOnly || !onChange}
                                type={type}
                                disabled={isDisabled}
                                as={as}
                                rows={as === "textarea" ? rows : undefined}
                                placeholder={placeholder}
                                {...(bsPrefix && { bsPrefix })}
                            />
                        )}
                    </InputGroup>
                )}
            </Col>
        </Form.Group>
    );
};

export default RenderDetailField;